
console.log("loaded")
function saveNotesPdp(e,productID) {
   console.log("$(`#fsQuickShopHolder-${productID} #save-note-pdp`)",productID)
  if (
    $("#note-trigger-pdp").is(":checked") &&
    checkAddGiftForm($("#note-wrap-pdp")) == false && checkAddGiftForm($("#note-wrap")) == false
  ) {
    return;
  } else if (
    $("#note-trigger-pdp").is(":checked") &&
    checkAddGiftForm($("#note-wrap-pdp")) && checkAddGiftForm($("#note-wrap"))
  ) {
    let giftees_email = $("#giftees-email-pdp").val();
    let giftees_first_name = $("#giftees-first-name-pdp").val();
    let giftees_last_name = $("#giftees-last-name-pdp").val();
    let giftees_message = $("#gift-message-pdp").val();
    let name = giftees_first_name + " " + giftees_last_name;
    let note = "Gift Note: " + giftees_message;

    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: {
        attributes: {
          "Giftee Name": name,
          "Giftee Email": giftees_email,
          undigital_giftee_name: name,
          undigital_giftee_message: giftees_message,
          "Giftee Message": giftees_message,
        },
        note: note,
      },
      dataType: "json",
      beforeSend: function () {
        $(`#fsQuickShopHolder-${productID} #save-note-pdp`).text("Saving...")
      },
      success: function (result) {
        $(`#fsQuickShopHolder-${productID} #save-note-pdp`).text("Saved!");
        if (!$("#note-trigger").is(":checked")) {
          $("#note-trigger").attr("checked", "checked");
          $("#note-trigger").val("yes");
          $('#note-wrap').slideToggle('500');
          $('.edit-option').show(200);
        }
        $("#giftees-email").val(giftees_email);
        $("#giftees-first-name").val(giftees_first_name);
        $("#giftees-last-name").val(giftees_last_name);
        $("#gift-message").val(giftees_message);
      },
      complete: function () {
        setTimeout(function () { $(`#fsQuickShopHolder-${productID} #save-note-pdp`).text("Save") }, 1500)
      },
      error: function (err) {
        console.log("error", err);
      },
    });
  }
}

function setCookie(name, value) {
  var d = new Date();
  d.setTime(d.getTime() + (1 * 24 * 60 * 60 * 1000));

  var expires = "expires=" + d.toGMTString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
}
function getCookie(name) {
  var cname = name + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(cname) == 0) {
      return c.substring(cname.length, c.length);
    }
  }
  return "";
}


var emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
function checkAddGiftForm(container) {

  var error_msg = "<span class='GiftErrorMsg'>This is a mandatory field</span>";
  var invalidEmail = "<span class='GiftErrorMsg'>This is an invalid email!</span>";
  var is_empty = false;
  if (container.find('#giftees-email-pdp').val() == '') {
    if (container.find('#giftees-email-pdp').parent().find('.GiftErrorMsg').length == 0)
      container.find('#giftees-email-pdp').parent().append(error_msg); is_empty = true;
  }
  else if (!emailRegex.test(container.find('#giftees-email-pdp').val())) {
    container.find('#giftees-email-pdp').parent().find('.GiftErrorMsg').remove();
    container.find('#giftees-email-pdp').parent().append(invalidEmail);
  }
  else { container.find('#giftees-email-pdp').parent().find('.GiftErrorMsg').remove() }

  if (container.find('#giftees-first-name-pdp').val() == '') {
    if (container.find('#giftees-first-name-pdp').parent().find('.GiftErrorMsg').length == 0)
      container.find('#giftees-first-name-pdp').parent().append(error_msg); is_empty = true;
  }
  else { container.find('#giftees-first-name-pdp').parent().find('.GiftErrorMsg').remove() }

  if (container.find('#giftees-last-name-pdp').val() == '') {
    if (container.find('#giftees-last-name-pdp').parent().find('.GiftErrorMsg').length == 0)
      container.find('#giftees-last-name-pdp').parent().append(error_msg); is_empty = true;
  }
  else {
    container.find('#giftees-last-name-pdp').parent().find('.GiftErrorMsg').remove()
  }

  if (container.find('#gift-message-pdp').val() == '') {
    if (container.find('#gift-message-pdp').parent().find('.GiftErrorMsg').length == 0)
      container.find('#gift-message-pdp').parent().append(error_msg); is_empty = true;
  }
  else {
    container.find('#gift-message-pdp').parent().find('.GiftErrorMsg').remove()
  }

  if (is_empty) {
    return false;
  }

  return true;
}

$(document).ready(function () {
  $("#giftees-first-name-pdp").val(getCookie("gFName"));
  $("#giftees-last-name-pdp").val(getCookie("gLName"));
  $("#giftees-email-pdp").val(getCookie("gEmail"));
  $("#gift-message-pdp").val(getCookie("gMsg"));
  if (getCookie("giftCheckBox") == "checked") {
    $("#note-trigger-pdp").attr("checked", "checked");
    $("#note-trigger-pdp").val("yes");
    $('#note-wrap-pdp').slideToggle('500');
    $('.edit-option-pdp').show(200);

    countChar = $("#gift-message-pdp").val().length;

    $("#no-of-chars-pdp").text(countChar + '/' + 200)

  }
  const giftNotelabel = $('.note-trigger-pdp');
  console.log("giftNotelabel", giftNotelabel);
  if (giftNotelabel) {
    giftNotelabel.each(function(){
      console.log("element", this)
      $(this).click(function () {
        countChar = $("#gift-message-pdp").val().length;
        console.log("this", this)
        $("#no-of-chars-pdp").text(countChar + '/' + 200)


        if ($(this).is(":checked")) {
          $(this).val("yes");
          $('#note-wrap-pdp').slideToggle('500');
          $('.edit-option-pdp').show(200);
        }
        else {
          $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: { attributes: { "Giftee Name": '', "Giftee Email": '', "Giftee Message": '' }, note: '' },
            dataType: 'json'
          });
          $('#note-wrap-pdp').slideUp('500');
          $(this).val("no");
          $('.edit-option-pdp').hide(200);
        }


      });
          });
    }
  
  })
$('.edit-option-pdp').click(function () {
  $('#note-wrap-pdp').slideToggle('500');
  $(this).toggleClass('rotated-icon');
});
$('#note-trigger-pdp').change(function () {
  $(this).is(':checked') ? setCookie("giftCheckBox", "checked") : setCookie("giftCheckBox", "unChecked")
});

$("#giftees-first-name-pdp").change(function () { setCookie("gFName", $(this).val()) });
$("#giftees-last-name-pdp").change(function () { setCookie("gLName", $(this).val()) });
$("#giftees-email-pdp").change(function () { setCookie("gEmail", $(this).val()) });
$("#gift-message-pdp").on('change keydown keyup', function () {
  countChar = $(this).val().length

  $("#no-of-chars-pdp").text(countChar + '/' + 200)
  setCookie("gMsg", $(this).val())
});

        function giftnoteClick(){
          const giftNotelabel = $('.note-trigger-pdp');
     console.log("giftNotelabel", giftNotelabel);
      if (giftNotelabel) {
        giftNotelabel.each(function() {
          console.log("element", this)
          $(this).click(function () {
            countChar = $("#gift-message-pdp").val().length;
            console.log("this", this)
            $("#no-of-chars-pdp").text(countChar + '/' + 200)


            if ($(this).is(":checked")) {
              $(this).val("yes");
              console.log("pdp-wrap", $('#note-wrap-pdp'),$('.edit-option-pdp'))
              $('.note-wrap-pdp').each(function(){
                $(this).slideToggle('500');
              });
            
              $('.edit-option-pdp').each(function(){
                $(this).show(200);
              });
            }
            else {
              $.ajax({
                type: 'POST',
                url: '/cart/update.js',
                data: { attributes: { "Giftee Name": '', "Giftee Email": '', "Giftee Message": '' }, note: '' },
                dataType: 'json'
              });
              $('.note-wrap-pdp').each(function(){
                $(this).slideUp('500');
              });
              $(this).val("no");
              $('.edit-option-pdp').each(function(){
                $(this).hide(200);
              });
            }


          });
              });
        }
      }
        
    
      function fsQuickViewModal(quickBtn){
       if (quickBtn) {
          quickBtn.addEventListener("click", function(e) {
            e.preventDefault();
            // Trigger modal open event for quickview
            const event = new CustomEvent('fs-custom-events-quick-view-btn-clicked', {
              detail: {
                productHandle: quickBtn.getAttribute('data-handle'),
                productID: quickBtn.getAttribute('data-product-id')
              }
            });
            window.dispatchEvent(event);
          });
        }
        // Modal logic: Listen for the event and show modal
        if (!window.__fs_quickview_modal_listener) {
          window.addEventListener('fs-custom-events-quick-view-btn-clicked', async function(e) {
            let productHandle = e.detail.productHandle;
            let productID = e.detail.productID;
            let modalId = `fsQuickShopHolder-${productID}`;
            let modal = document.getElementById(modalId);
            let fsProducturl = theme.routes.home + "/products/" + productHandle;
            fsProducturl = fsProducturl.replace(/\/\/+/, "/");
            if (!modal) {
              modal = document.createElement('div');
              modal.id = modalId;
              modal.classList.add("fs-modal", "modal--square", "modal--quick-shop");
              modal.dataset.productID = productID;
              modal.innerHTML = `<div class="fs-modal-overlay"></div><span class="fs-quickview-close">&times;</span><div class="fs-quickview-content">Loading...</div>`;
              document.body.appendChild(modal);
              modal.querySelector('.fs-quickview-close').onclick = function() {
                modal.style.display = 'none';
                document.body.style.overflow = 'auto';
                  modal.classList.remove("open");
              };
              try {
                const response = await fetch(fsProducturl);
                const text = await response.text();
                const html = document.createElement("div");
                html.innerHTML = text;
                const div = html.querySelector('.product-section[data-product-handle="' + productHandle + '"]');
                if (div) {
                  modal.querySelector('.fs-quickview-content').innerHTML = '';
                  modal.querySelector('.fs-quickview-content').appendChild(div);
                  // Register product template inside quick view
                  if (window.theme && theme.sections && theme.Product) {
                    theme.sections.register("product", theme.Product, modal);
                    
                  }
                  // Register collapsible elements
                  if (window.theme && theme.collapsibles) {
                    theme.collapsibles.init();
                  }
                  // Register potential video modal links (when video has sound)
                  if (window.theme && theme.videoModal) {
                    theme.videoModal();
                  }
                  modal.querySelector(".atc-and-gift-btns button").style.display = "block";
                  giftnoteClick();
                    document.body.addEventListener("change", (e) => {
          if (e.target.matches("#note-trigger-pdp")) {
              if (e.target.checked) {
                setCookie("giftCheckBox", "checked");

              } else {
                setCookie("giftCheckBox", "unChecked");
              }
              
            }
          });
          if(getCookie("giftCheckBox")=="checked") { 
                document.querySelector("#note-trigger-pdp").setAttribute("checked","checked");
                  document.querySelector("#note-trigger-pdp").setAttribute("value","yes"); 
                  console.log("notee")
                  console.log($('#note-wrap-pdp'),"note")
                  $('#note-wrap-pdp').slideToggle('500'); 
                  $('.edit-option-pdp').show(200); 
                
                countChar=$("#gift-message-pdp").val().length;
                
                  $("#no-of-chars-pdp").text( countChar + '/' + 200 )
      
          } else{
              $('#note-wrap-pdp').slideUp('500');
                document.querySelector("#note-trigger-pdp").setAttribute("value","no"); 
                $('.edit-option-pdp').hide(200); 
          }
        document.querySelector(`#fsQuickShopHolder-${productID} #save-note-pdp`).addEventListener("click",(e)=>{
          console.log("click")
          saveNotesPdp(e,productID)
        })
                //  modal.querySelector(".e-gift-heading-div").style.display = "none";
                  setTimeout(()=>{
                    const swatches = modal.querySelectorAll("variant-king-combined-listing");
                      if (swatches.length > 1) {
                        swatches.forEach((el, index) => {
                          if (index !== 0) {
                            el.remove();
                          }
                        });
                    }
                  },1000);
                        modal.classList.add("open");
                  document.body.style.overflow = 'hidden';
                } else {
                  modal.querySelector('.fs-quickview-content').innerHTML = 'Product not found.';
                  document.body.style.overflow = 'hidden';
                }
                modal.style.display = 'block';
              } catch (err) {
                modal.querySelector('.fs-quickview-content').innerHTML = 'Error loading product.';
                document.body.style.overflow = 'hidden';
                console.error(err);
              }
            } else {
              modal.style.display = 'block';
              document.body.style.overflow = 'hidden';
            }

          modal.querySelector(".cro-pdp-updates button").addEventListener("click",function(e){
              let modalForm = modal.querySelector("form");
              if (modalForm) {
                // Collect form data
                const formData = new FormData(modalForm);
                // Build payload for Shopify AJAX cart API
                let payload = {};
                for (let [key, value] of formData.entries()) {
                  payload[key] = value;
                }
                // Default endpoint for Shopify AJAX cart
                fetch('/cart/add.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                  },
                  body: JSON.stringify(payload)
                })
                .then(response => response.json())
                .then(data => {
                  document.dispatchEvent(new CustomEvent('cart:build'));
                  document.getElementById('HeaderCartTrigger').click();
                  modal.classList.remove("open");
                  modal.style.display = 'none';
                  document.body.style.overflow = 'auto';
                })
                .catch(error => {
                  console.error('Error adding to cart:', error);
                  modal.classList.remove("open");
                  modal.style.display = 'none';
                  document.body.style.overflow = 'auto';
                });
              } else {
                  document.dispatchEvent(new CustomEvent('cart:build'));
                  document.getElementById('HeaderCartTrigger').click();
                modal.classList.remove("open");
                modal.style.display = 'none';
                document.body.style.overflow = 'auto';
              }
            });
          });
          window.__fs_quickview_modal_listener = true;
        }
}
